export function runContextsFromSessionData(sessionData) {
  const session = sessionData?.session;
  if (!session?.agent_id) return [];
  const messages = Array.isArray(sessionData?.messages) ? sessionData.messages : [];
  const contexts = [];
  const seen = new Set();
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const message = messages[index];
    const runNumber = Number(message?.run_number || 0);
    if (!runNumber) continue;
    const version = Number(message?.agent_version || session.agent_version || 0);
    if (!version) continue;
    const key = `${session.agent_id}:${version}:${runNumber}`;
    if (seen.has(key)) continue;
    seen.add(key);
    contexts.push({
      agentId: session.agent_id,
      version,
      runNumber,
    });
  }
  return contexts;
}

export function latestRunContextFromSessionData(sessionData) {
  return runContextsFromSessionData(sessionData)[0] || null;
}
